import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { fetch_share_holders_data } from "../../ApisService/apiService";

ChartJS.register(ArcElement, Tooltip, Legend);

const ShareholdingPieChart = ({ fincode }) => {
  const [shareData, setShareData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const safe = (val) => {
    if (!val || val === "-") return 0;
    return parseFloat(String(val).replace(/,/g, "")) || 0;
  };

  useEffect(() => {
    if (!fincode) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch_share_holders_data(fincode);
        const data = response?.data;
        if (Array.isArray(data) && data.length > 0) {
          setShareData(data[0]); // Latest year's data
        } else {
          setError("No shareholding data found.");
        }
      } catch (err) {
        setError("Failed to fetch shareholding data.");
      }
      setLoading(false);
    };

    fetchData();
  }, [fincode]);

  const pieData = {
    labels: [
      "Promoter",
      "FII",
      "Mutual Funds/UTI",
      "Govt",
      "Institutions",
      "Individuals",
      "Others",
      "Depository Receipts",
    ],
    datasets: [
      {
        data: shareData
          ? [
              safe(shareData.nhFtotalpromoter),
              safe(shareData.nhINFII),
              safe(shareData.nhINMFUTI),
              safe(shareData.nhINcgovt),
              safe(shareData.nhINSubtotal),
              safe(shareData.nhNINIndivd),
              safe(shareData.Others_two || 0),
              safe(shareData.nhCustodianDRs),
            ]
          : [],
        backgroundColor: [
          "#1E88E5",
          "#D32F2F",
          "#43A047",
          "#FB8C00",
          "#6A1B9A",
          "#3949AB",
          "#00897B",
          "#FDD835",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "right",
      },
    },
  };

  return (
    <div style={{ maxWidth: "300px", margin: "auto" }}>
      {loading && <p>Loading shareholding chart...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && shareData && (
        <>
          <h3 style={{ textAlign: "center" }}>Shareholding Pattern</h3>
          <Pie data={pieData} options={options} />
        </>
      )}
    </div>
  );
};

export default ShareholdingPieChart;
